import {EmailTemplatesServiceInterface} from '../../../../services/email-templates-service.interface';
import {ToastService} from 'angular-toastify';
import {
  TemplateSendPreviewDialogComponent
} from '../../../../shared/template-send-preview-dialog/template-send-preview-dialog.component';
import {TemplateSendPreviewModel} from '../../../../../models/template-send-preview-model';
import {MatDialog} from '@angular/material/dialog';

export abstract class EmailTemplatesEditComponentBase {
  protected constructor(
    private _templateService: EmailTemplatesServiceInterface,
    private _toastService: ToastService,
    private _dialog: MatDialog) {

    }

    public abstract sendPreview();

  protected sendPreviewBase(html: string, selectedLanguage: number, emailPrefill: string, templateId: number) {

    this._dialog.open(TemplateSendPreviewDialogComponent, {data: {templateId, email: emailPrefill}}).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof TemplateSendPreviewModel) {
          dlgResult.language = selectedLanguage;
          dlgResult.html = html;
          this._templateService.sendPreviewEmail(dlgResult).subscribe(result => {
            this._toastService.success('Template has been sent to ' + result.email);
          });
        }
      }, err => {
        this.showError(err.error.message || err.error || err.message || err);
      });
  }


  protected showError(message) {
    this._toastService.error(message);
  }


}
